import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Button = styled(m.button) `
  ${transition('transform')};
  ${ButtonReset};

  position: absolute;
  top: calc(${fluid(12, 24)} * -1);
  right: 0;
  margin: 0;
  display: grid;
  background: var(--bgColor);
  color: ${brand.primary.white};
  height: var(--buttonSize);
  place-content: center;
  place-items: center;
  width: var(--buttonSize);
  transform: translateY(-100%);

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  &.focus-ring {
    outline: auto;
    outline-color: currentColor;
    outline-offset: 5px;
    outline-width: thin;
  }

  &.focus-ring,
  &:hover {
    transform: translateY(-100%) scale(0.85);
  }
`;
const CloseStyles = {
    Button,
};
export default CloseStyles;
